/* Orchard 2026 buy box: variants (price, image, ?variant=, hidden id), selling plans (one-time / subscribe & save), qty, AJAX add. */
(function () {
  'use strict';
  function init(box) {
    if (box.dataset.oInit) return; box.dataset.oInit = '1';
    var json = box.querySelector('[data-o-product-json]');
    if (!json) return;
    var product = JSON.parse(json.textContent);
    var form = box.querySelector('form[data-o-buy]') || box;
    var idInput = form.querySelector('input[name="id"]');
    var planInput = form.querySelector('input[name="selling_plan"]');
    var qtyOut = box.querySelector('[data-o-qty-out]');
    var qtyInput = form.querySelector('input[name="quantity"]');
    var addBtn = box.querySelector('[data-o-submit]');
    var label = addBtn && addBtn.querySelector('[data-o-label]');
    var totalEl = addBtn && addBtn.querySelector('[data-o-total]');
    var freqWrap = box.querySelector('[data-o-freqs]');
    var section = box.closest('[data-o-product-section]') || document;
    var money = window.OrchardMoney;
    var state = { variant: product.variants.find(function (v) { return String(v.id) === String(idInput.value); }) || product.variants[0], plan: 'once', planId: null, qty: 1 };
    var firstFreq = box.querySelector('[data-o-freq][aria-checked="true"]') || box.querySelector('[data-o-freq]');
    if (firstFreq) state.planId = firstFreq.dataset.planId;
    if (product.requires_selling_plan) state.plan = 'sub';

    function alloc(v, planId) {
      if (!v.selling_plan_allocations) return null;
      return v.selling_plan_allocations.find(function (a) { return String(a.selling_plan_id) === String(planId); }) || null;
    }
    function isPack(v) { var t = (v.title || '').toLowerCase(); return t.indexOf('single') === -1 && /pack|4/.test(t); }
    function unit() {
      if (state.plan === 'sub' && state.planId) { var a = alloc(state.variant, state.planId); if (a) return a.price; }
      return state.variant.price;
    }
    /* sticky add-to-bag bar (mobile). Lives right after this buy box. */
    var sticky = box.nextElementSibling && box.nextElementSibling.matches('[data-o-sticky]') ? box.nextElementSibling : null;
    function renderSticky(v, subOn) {
      if (!sticky) return;
      var sv = sticky.querySelector('[data-o-sticky-var]'), sp = sticky.querySelector('[data-o-sticky-price]');
      var sb = sticky.querySelector('[data-o-sticky-add]'), sl = sticky.querySelector('[data-o-sticky-label]');
      var chip = box.querySelector('[data-o-variant][aria-checked="true"]');
      if (sv && chip) sv.textContent = ((chip.querySelector('b') || chip).textContent || '').trim();
      if (sp) sp.textContent = money(unit() * state.qty);
      if (sb) sb.disabled = !v.available;
      if (sl) sl.textContent = !v.available ? 'sold out' : (subOn ? 'subscribe' : 'add to bag');
    }
    if (sticky && 'IntersectionObserver' in window) {
      var mq = window.matchMedia('(max-width:759px)');
      var boxOut = false, footIn = false;
      var foot = document.querySelector('.shopify-section-group-footer-group, footer');
      var sync = function () {
        var drawerOpen = !!document.querySelector('cart-drawer.active, cart-drawer.is-open');
        var gate = !document.documentElement.classList.contains('o-age-ok') && document.querySelector('[data-o-age]');
        var on = mq.matches && boxOut && !footIn && !drawerOpen && !gate;
        sticky.classList.toggle('is-on', on);
        sticky.setAttribute('aria-hidden', String(!on));
        if (on) sticky.removeAttribute('inert'); else sticky.setAttribute('inert', '');
      };
      /* keep references so the observers are never garbage-collected */
      window.__oStickyIO = window.__oStickyIO || [];
      var io1 = new IntersectionObserver(function (es) { es.forEach(function (e) { boxOut = !e.isIntersecting && e.boundingClientRect.top < 0; }); sync(); });
      io1.observe(addBtn || box); window.__oStickyIO.push(io1);
      if (foot) { var io2 = new IntersectionObserver(function (es) { es.forEach(function (e) { footIn = e.isIntersecting; }); sync(); }); io2.observe(foot); window.__oStickyIO.push(io2); }
      window.addEventListener('scroll', function () {
        var r = (addBtn || box).getBoundingClientRect(); boxOut = r.bottom < 0;
        if (foot) { var f = foot.getBoundingClientRect(); footIn = f.top < window.innerHeight && f.bottom > 0; }
        sync();
      }, { passive: true });
      document.addEventListener('click', function () { setTimeout(sync, 50); setTimeout(sync, 600); });
      var cd = document.querySelector('cart-drawer'); if (cd && 'MutationObserver' in window) new MutationObserver(sync).observe(cd, { attributes: true, attributeFilter: ['class'] });
      if (mq.addEventListener) mq.addEventListener('change', sync);
      sticky.querySelector('[data-o-sticky-add]').addEventListener('click', function (e) {
        e.preventDefault(); if (!addBtn || addBtn.disabled) return;
        if (form.requestSubmit) form.requestSubmit(addBtn); else addBtn.click();
      });
    }
    function render() {
      var v = state.variant;
      idInput.value = v.id;
      var va = state.planId ? alloc(v, state.planId) : null;
      if (!va && !product.requires_selling_plan) state.plan = 'once';
      var subOn = state.plan === 'sub' && !!va;
      var subBtn = box.querySelector('[data-o-plan="sub"]');
      if (subBtn) subBtn.hidden = !va;
      if (planInput) { planInput.value = subOn ? state.planId : ''; planInput.disabled = !subOn; }
      box.querySelectorAll('[data-o-variant]').forEach(function (b) { b.setAttribute('aria-checked', String(b.dataset.variantId) === String(v.id)); });
      box.querySelectorAll('[data-o-plan]').forEach(function (b) { b.setAttribute('aria-checked', b.dataset.oPlan === state.plan); });
      box.querySelectorAll('[data-o-freq]').forEach(function (b) { b.setAttribute('aria-checked', String(b.dataset.planId) === String(state.planId)); });
      if (freqWrap) freqWrap.hidden = !subOn;
      var once = box.querySelector('[data-o-plan="once"] [data-o-plan-price]');
      if (once) once.textContent = money(v.price);
      var sub = box.querySelector('[data-o-plan="sub"] [data-o-plan-price]');
      if (sub) { var a = alloc(v, state.planId); sub.textContent = a ? money(a.price) : money(v.price); }
      if (qtyOut) qtyOut.textContent = state.qty;
      if (qtyInput) qtyInput.value = state.qty;
      if (totalEl) totalEl.textContent = money(unit() * state.qty);
      if (addBtn) {
        addBtn.disabled = !v.available; addBtn.classList.toggle('is-soldout', !v.available);
        if (label) label.textContent = !v.available ? 'sold out' : (state.plan === 'sub' ? 'subscribe' : 'add to bag');
      }
      renderSticky(v, subOn);
      section.querySelectorAll('[data-o-packimg]').forEach(function (el) { el.hidden = !isPack(v); });
      if (v.featured_image && box.dataset.swapImage === 'true') {
        section.querySelectorAll('[data-o-mainimg]').forEach(function (img) { img.src = v.featured_image.src + (v.featured_image.src.indexOf('?') > -1 ? '&' : '?') + 'width=1200'; img.removeAttribute('srcset'); img.alt = v.featured_image.alt || img.alt; });
      }
    }
    box.addEventListener('click', function (e) {
      var t;
      if ((t = e.target.closest('[data-o-variant]'))) {
        e.preventDefault();
        state.variant = product.variants.find(function (v) { return String(v.id) === t.dataset.variantId; }) || state.variant;
        var u = new URL(window.location.href); u.searchParams.set('variant', state.variant.id); history.replaceState(null, '', u.toString());
        render();
      } else if ((t = e.target.closest('[data-o-plan]'))) { e.preventDefault(); if (t.hidden) return; state.plan = t.dataset.oPlan; render(); }
      else if ((t = e.target.closest('[data-o-freq]'))) { e.preventDefault(); state.planId = t.dataset.planId; render(); }
      else if ((t = e.target.closest('[data-o-qty]'))) { e.preventDefault(); state.qty = Math.max(1, state.qty + Number(t.dataset.oQty)); render(); }
    });
    form.addEventListener('submit', function (e) {
      if (!window.Orchard || !window.Orchard.cartAdd) return;
      e.preventDefault();
      if (addBtn.disabled) return;
      var item = { id: state.variant.id, quantity: state.qty };
      if (state.plan === 'sub' && state.planId && alloc(state.variant, state.planId)) item.selling_plan = Number(state.planId);
      window.Orchard.cartAdd([item], addBtn).then(function () {
        if (label) { label.textContent = 'added'; setTimeout(render, 2400); }
      }).catch(function () {});
    });
    render();
  }
  document.querySelectorAll('[data-o-buybox]').forEach(init);
})();
